export var CurrencyPosition;
(function (CurrencyPosition) {
    CurrencyPosition[CurrencyPosition["LEFT"] = 0] = "LEFT";
    CurrencyPosition[CurrencyPosition["RIGHT"] = 1] = "RIGHT";
})(CurrencyPosition || (CurrencyPosition = {}));
export const formatPrice = (amount = 0, currencyCode = 'USD', locale) => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
    }).format(amount);
};
export const parsePriceComponents = (amount = 0, currency = 'USD', locale) => {
    var _a;
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    });
    const parts = formatter.formatToParts(amount);
    const currencySymbol = parts.find((part) => part.type === 'currency').value;
    const basePart = parts
        .filter((part) => part.type === 'integer' || part.type === 'group')
        .map((part) => part.value)
        .join('');
    const fractionalPart = ((_a = parts.find((part) => part.type === 'fraction')) === null || _a === void 0 ? void 0 : _a.value) || '';
    const currencyIndex = parts.findIndex((part) => part.type === 'currency');
    const integerIndex = parts.findIndex((part) => part.type === 'integer');
    const currencySymbolPosition = currencyIndex < integerIndex ? CurrencyPosition.LEFT : CurrencyPosition.RIGHT;
    return {
        currencySymbol,
        basePart,
        fractionalPart,
        currencySymbolPosition,
    };
};
